import React from 'react'

import { DateInput } from '@pb/components'
import { useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'
import { DateFieldConfig } from 'App/duck/types'

import { getFieldsInOrderBy } from '../../getFieldsBy'

const DateOfBirth: React.FC<any> = (props) => {
  const fieldsConfig = useSelector(appSelectors.getFieldsConfig)
  const fieldsOrdering = useSelector(appSelectors.getFieldsOrdering)

  const dateFields = getFieldsInOrderBy('DATE', fieldsConfig, fieldsOrdering) as DateFieldConfig[]

  const order = dateFields.map(({ attribute, placeholder, separator }) => ({
    datePart: attribute,
    placeholder,
    separator,
  }))

  return <DateInput order={order} {...props} />
}

export default DateOfBirth
